export default "__VITE_ASSET__Ct$vxMRN__"